import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import moment from "moment-timezone";
import {
  getFollowerSuggestion,
  getuserInfo,
} from "../store/actions/userActions";
import {
  getCalendarScheduleInfo,
  removeBlockedDates,
} from "../store/actions/calendarActions";
import UserListView from "./UserListView";
import NoDataAvailable from "./NoDataAvailable";
import { Link, useLocation } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "../shared/const.prop";
import { capitalizeEachWord } from "../../utils/application-helper";
import SuggestForYou from "./SuggestForYou";
import Calendar from "react-calendar";
import undrawProfile from "../img/undraw_profile.svg";
import "react-calendar/dist/Calendar.css";
const RightSideBar = ({ calenderMobView }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const { calendarScheduleInfo } = useSelector((state) => state.calendar);
  const [sideBarType, setSideBarType] = useState("basic");
  const { followerSuggestion } = useSelector((state) => state.user);
  const [followerSuggestionList, setFollowerSuggestionList] =
    useState(followerSuggestion);
  const [scheduleList, setScheduleList] = useState([]);
  const [loading, setLoading] = useState(true);

  const path = location.pathname;
  //Calendar details
  const [slotDate, setSlotDate] = useState(moment().format("YYYY-MM-DD"));
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [duration, setDuration] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [availableDates, setAvailableDates] = useState([]);
  const [upcomingDates, setUpcomingDates] = useState([]);
  const [status, setStatus] = useState("bookedByMe");
  const [slotList, setSlotList] = useState("");

  const handleRequest = async (userId, status, follower) => {
    try {
      const followApi = await axiosHttp.post("follow", {
        userId,
        status,
      });
      if (followApi.status === 201) {
        dispatch(getFollowerSuggestion());
        appContext.updateNotificationState({
          show: true,
          type: "success",
          message: `You gave  follow request to ${follower?.fName} ${follower?.lName}`,
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          type: "error",
          message: "Error, please try after sometime.",
        });
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  useEffect(() => {
    dispatch(getFollowerSuggestion(appContext.category));
  }, [appContext.category]);

  useEffect(() => {
    getBookingsList();
  }, [path, status]);

  useEffect(() => {
    // fetchSlotDates()
    // getTimeZone();
    fetchCurrentSchedule(slotDate);
  }, []);

  useEffect(() => {
    setSideBarType("basic");
    if (location.pathname === "/myspace/calendar") {
      setSideBarType("calendarSideBar");
    }

    //(location.pathname === "/myspace/connections") ? setSuggestion(false) : setSuggestion(true)
    // console.log("location.pathname", location.pathname)
  }, [location.pathname]);

  useEffect(() => {
    const d = Object.values(followerSuggestion).slice(0, 3);
    setFollowerSuggestionList(d);
    setLoading(false);
  }, [followerSuggestion]);

  const getBookingsList = async () => {
    try {
      const getScheduleList = await axiosHttp.get(
        `appointments?status=Upcoming&type=${status}`
      );
      if (getScheduleList.status === 200) {
        let availableDates = [];
        let data = getScheduleList?.data?.data;

        // const today = new Date().toISOString().split("T")[0];

        // const todayEvents = data.filter((event) =>
        //   event.start_time.startsWith(today)
        // );

        data.sort((a, b) => (a.start_time > b.start_time ? 1 : -1));
        data.map((item) => {
          availableDates.push(moment(item.start_time).format("DD-MM-YYYY"));
        });

        const firstThreeEvents = data.slice(0, 3);
        setAvailableDates(availableDates);
        setScheduleList(firstThreeEvents);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      setScheduleList([]);
      //console.log(e);
    }
  };

  const fetchCurrentSchedule = async (formattedDate) => {
    try {
      const getCurrentSchedule = await axiosHttp.get(
        `appointments/single-date?date=${formattedDate}`
      );
      if (getCurrentSchedule.status === 200) {
        let data = getCurrentSchedule?.data?.data;
        setSlotList(data);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(e);
    }
  };

  const successCallback = (msg = "") => {
    appContext.updateNotificationState({
      type: "success",
      message: msg ? msg : "Blocked Dates updated",
      show: true,
    });
  };

  // console.log(availableDates);

  const failureCallback = (e) => {
    if (e.response.status === 429) {
      appContext.updateNotificationState({
        show: true,
        type: "error",
        message: errorResponseMessage(e),
      });
      authContext.logout();
    }
    if (e.response.status === 400) {
      appContext.updateNotificationState({
        show: true,
        message: errorResponseMessage(e),
        type: "error",
      });
    }
  };

  const handleSlotDate = (date) => {
    setSlotDate(date);
    const formattedDate = moment(date).format("YYYY-MM-DD");
    fetchCurrentSchedule(formattedDate);
  };
  const tileDisabled = ({ date }) => {
    const formattedDate = moment(date).format("YYYY-MM-DD");
    return !availableDates.includes(formattedDate) ? true : null;
  };

  const myZone = localStorage.getItem("zone");

  return (
    <>
      {sideBarType === "basic" ? (
        <>
          {!path.includes("connections") && userData?.offerService && (
            <div className="card d-none-mob upcoming-session-desktopview">
              <div className="card-body">
                <p className="follow-txt">Upcoming Session</p>
                <nav className="mb-2">
                  <div
                    className="nav nav-tabs no-wrap"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      className={
                        status === "bookedByMe"
                          ? "nav-item nav-link active"
                          : "btn nav-item nav-link"
                      }
                      onClick={() => setStatus("bookedByMe")}
                    >
                      My Bookings
                    </button>
                    <button
                      className={
                        status === "bookedForMe"
                          ? "nav-item nav-link active"
                          : "btn nav-item nav-link"
                      }
                      onClick={() => setStatus("bookedForMe")}
                    >
                      My Reservations
                    </button>
                  </div>
                </nav>
                {scheduleList.length === 0 ? (
                  <p>There are no upcoming calls scheduled</p>
                ) : (
                  <>
                    {scheduleList.map((item) => {
                      const start = moment(item?.start_time);
                      const end = moment(item?.end_time);
                      return (
                        <div className="col-md-12 px-0">
                          <p className="profile-name mb-0">
                            {item.service_name &&
                              capitalizeEachWord(item.service_name)}
                          </p>
                          <p className="mt-1 mb-0">
                            {start.tz(myZone).format("DD/MM/YYYY")}
                          </p>
                          <p>
                            {start.tz(myZone).format("h:mm A")} -{" "}
                            {end.tz(myZone).format("h:mm A")}
                          </p>
                        </div>
                      );
                    })}
                    <hr />
                    <p className="text-center text-primary mb-0 cursor-pointer">
                      <Link to={`../myspace/schedule`}>
                        <b>See All</b>
                      </Link>
                    </p>
                  </>
                )}
              </div>
            </div>
          )}
          {loading ? (
            <p>Fetching suggestions</p>
          ) : (
            followerSuggestionList && (
              <div className="d-none-mob">
                <SuggestForYou
                  followerSuggestionList={followerSuggestionList}
                  path={path}
                />
              </div>
            )
          )}
        </>
      ) : (
        <>
          {userData?.offerService && (
            <div className="calendar-wrapper mb-2">
              <Calendar
                onChange={handleSlotDate}
                value={slotDate}
                className={
                  calenderMobView
                    ? "custom-calendar"
                    : "custom-calendar d-none-mob"
                }
                // minDate={new Date(min)
                // maxDate={new Date(max)}
                // tileClassName={tileClassName}
                // disabled={tileClassName}
                // tileDisabled={tileDisabled}
              />
            </div>
          )}
          {userData?.offerService && slotList.length > 0 && (
            <div
              class={
                !calenderMobView
                  ? "card-one mb-2 scrollbar-card"
                  : "card mb-2 scrollbar-card"
              }
            >
              <div className="card-body">
                {slotList.map((item) => {
                  return (
                    <div className="col-md-12 px-0">
                      <p className="profile-name">
                        {item.service_name &&
                          capitalizeEachWord(item.service_name)}
                      </p>
                      {item.slots.length > 0 &&
                        item.slots.map((slot) => {
                          const start = moment(slot?.startTime);
                          const end = moment(slot?.endTime);
                          return (
                            <div className="mb-4">
                              <div className="d-flex align-items-center">
                                <img
                                  src={slot?.picUrl || undrawProfile}
                                  alt="pic"
                                  className="img-profile rounded-circle  ml-2"
                                />
                                <div className="calendar-card-slider">
                                  <p>
                                    <strong>{slot?.name}</strong>
                                  </p>
                                  <p className="mt-1">{`${start
                                    .tz(myZone)
                                    .format("h:mm A")} - ${end
                                    .tz(myZone)
                                    .format("h:mm A")}`}</p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {userData?.offerService && (
            <div class="card-one">
              <div class="card-body">
                <p class="profile-name mb-1">Block Dates</p>
                <p class="block">
                  Add dates when you will be unavailable to take calls
                </p>
                <p
                  class="btn pending-row text-center py-1 mb-1"
                  style={{ fontSize: "12px" }}
                  onClick={() =>
                    appContext.updateModalType(
                      "blockDates",
                      "Select Date your unavailable on"
                    )
                  }
                >
                  Add unavailable dates
                </p>
                <div class="row">
                  {calendarScheduleInfo?.unavailableDays &&
                    Array.isArray(calendarScheduleInfo.unavailableDays) &&
                    [...calendarScheduleInfo.unavailableDays]
                      .sort((a, b) => moment(a.date).diff(moment(b.date)))
                      .map(({ date }, index) => {
                        const today = moment();
                        if (moment(date).isSameOrAfter(today, "day"))
                          return (
                            <div className="d-flex justify-content-around align-items-center w-100 mb-3">
                              <div class="mt-1">
                                <p class="day-txt mb-0">
                                  {moment(date).isValid
                                    ? moment(date).format("DD MMM YYYY")
                                    : ""}
                                </p>
                              </div>
                              <div class="mt-1">
                                <p class="text-muted day-txt mb-0">
                                  Unavailable
                                </p>
                              </div>
                              <div class="cursor-pointer">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  onClick={() =>
                                    dispatch(
                                      removeBlockedDates(
                                        index,
                                        successCallback,
                                        failureCallback
                                      )
                                    )
                                  }
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.5385 6.53977C14.8482 6.56527 15.0792 6.83602 15.0544 7.14577C15.0499 7.19677 14.6435 12.23 14.4095 14.3413C14.264 15.6515 13.3984 16.4488 12.0919 16.4728C11.0922 16.49 10.1277 16.4998 9.18495 16.4998C8.1687 16.4998 7.17795 16.4885 6.1977 16.4683C4.9437 16.4435 4.07595 15.6305 3.9342 14.3465C3.69795 12.2165 3.2937 7.19602 3.28995 7.14577C3.26445 6.83602 3.49545 6.56453 3.8052 6.53977C4.11045 6.53152 4.38645 6.74603 4.4112 7.05503C4.41359 7.08758 4.57886 9.1378 4.75895 11.1663L4.79512 11.5711C4.88582 12.5794 4.97777 13.5483 5.05245 14.2228C5.1327 14.9525 5.52645 15.329 6.22095 15.3433C8.09595 15.383 10.0092 15.3853 12.0717 15.3478C12.8097 15.3335 13.2087 14.9645 13.2912 14.2175C13.5237 12.122 13.9287 7.10603 13.9332 7.05503C13.9579 6.74603 14.2317 6.53003 14.5385 6.53977ZM10.7591 1.5C11.4475 1.5 12.0528 1.96425 12.2305 2.6295L12.4211 3.57525C12.4826 3.88528 12.7547 4.11169 13.0697 4.11667L15.531 4.11675C15.8415 4.11675 16.0935 4.36875 16.0935 4.67925C16.0935 4.98975 15.8415 5.24175 15.531 5.24175L13.0917 5.24164C13.0879 5.24171 13.0841 5.24175 13.0803 5.24175L13.062 5.241L5.28121 5.24166C5.27517 5.24172 5.26911 5.24175 5.26305 5.24175L5.2515 5.241L2.8125 5.24175C2.502 5.24175 2.25 4.98975 2.25 4.67925C2.25 4.36875 2.502 4.11675 2.8125 4.11675L5.27325 4.116L5.34902 4.1112C5.63123 4.07459 5.86578 3.86025 5.92305 3.57525L6.1053 2.66325C6.29055 1.96425 6.8958 1.5 7.5843 1.5H10.7591ZM10.7591 2.625H7.5843C7.4043 2.625 7.24605 2.74575 7.2003 2.919L7.02555 3.7965C7.00334 3.90765 6.971 4.01476 6.92961 4.11695H11.414C11.3725 4.01476 11.3401 3.90765 11.3178 3.7965L11.1355 2.8845C11.0973 2.74575 10.939 2.625 10.7591 2.625Z"
                                    fill="#E80000"
                                    fillOpacity="0.6"
                                  />
                                </svg>
                              </div>
                            </div>
                          );
                      })}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default RightSideBar;
